import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

import { useLocale } from 'lib/helpers/useLocale'
import { PlatformType } from 'lib/types/platform'

import AuthScope from 'components/AuthScope.vue'

import SocialButton from './SocialButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthButton',
  props: {
    platform: null,
    requestUrl: null,
    plain: { type: Boolean },
    attaching: { type: Boolean },
    attached: { type: Boolean },
    demoAuth: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  platform: PlatformType
  requestUrl: string
  plain?: boolean
  attaching?: boolean
  attached?: boolean
  demoAuth?: boolean
}



const showScope = ref(false)
const socialButton = ref<InstanceType<typeof SocialButton>>()

const locale = computed(() => {
  switch (props.platform) {
    case 'twitch':
      return { startWith: useLocale('startWithTwitch') }
    case 'youtube':
      return { startWith: useLocale('startWithYoutube') }
    case 'trovo':
      return { startWith: useLocale('startWithTrovo') }
    case 'vkplay':
      return { startWith: useLocale('startWithVkplay') }
  }
})

const openScope = () => {
  if (props.attached) return
  showScope.value = true
}

return { __sfc: true,props, showScope, socialButton, locale, openScope, AuthScope, SocialButton }
}

})